import { ChainId } from "config/wagmi";
import { configs } from "./default";

export function getConfig(chainId: ChainId) {
  return configs[chainId as keyof typeof configs] || {};
}

export * from "./apolloClient";
